
<template>
	<div v-if="!item.hidden && integrationRequirementMet" class="menu-wrapper risolto-sidebar-item">
		<template v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
			<!-- in order to also disable the click, :to has to be set to empty -->
			<app-link v-if="onlyOneChild.meta" :to="licenceAndPermissionRequirementsAreMet ? resolvePath(onlyOneChild.path): ''" >
				<el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }" :disabled="!licenceAndPermissionRequirementsAreMet">
					<item
						:icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
						:title="$t(onlyOneChild.meta.title)"
						:disabled="!licenceAndPermissionRequirementsAreMet"
						:unread-count="unreadCount"
					/>
				</el-menu-item>
			</app-link>
		</template>

		<el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
			<template slot="title">
				<item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
			</template>
			<sidebar-item
				v-for="child in item.children"
				:key="child.path"
				:is-nest="true"
				:item="child"
				:base-path="resolvePath(child.path)"
				class="nest-menu"
			/>
		</el-submenu>
	</div>
</template>

<script>
import path from 'path';
import { isExternal } from '@/utils/validate';
import Item from './Item';
import AppLink from './Link';
import FixiOSBug from './FixiOSBug';
import { hasLicenseAndPermission } from '@/helpers/permission-helper';

export default {
	name: 'SidebarItem',
	components: { Item, AppLink },
	mixins: [FixiOSBug],
	props: {
		// route object
		item: {
			type: Object,
			required: true
		},
		isNest: {
			type: Boolean,
			default: false
		},
		basePath: {
			type: String,
			default: ''
		}
	},
	data() {
		// To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
		// TODO: refactor with render function
		this.onlyOneChild = null;
		return {};
	},
	computed: {
		unreadCount: function() {
			if (this.item.path === '/messages') {
				return this.$store.state.messages.unreadCount;
			}

			return 0;
		},
		integrationRequirementMet() {
			const requiredIntegration = this.item.meta?.required_integration;
			if (!requiredIntegration) return true;

			const participant = this.$store.state.risolto.selectedParticipantStore;
			const integrations = this.$store.state.risolto.integrations[participant];
			return integrations?.some(i => i.external_system === requiredIntegration) ?? false;
		},
		licenceAndPermissionRequirementsAreMet() {
			const { required_licence, required_permission } = this.item.meta;
			const selectedParticipantStore = this.$store.state.risolto.selectedParticipantStore;
			const licences = this.$store.state.risolto.licences[selectedParticipantStore];
			const permissions = this.$store.state.risolto.permissions[selectedParticipantStore];

			return hasLicenseAndPermission(
				licences,
				permissions,
				required_licence,
				required_permission
			);
		}
	},
	methods: {
		hasOneShowingChild(children = [], parent) {
			const showingChildren = children.filter(item => {
				if (item.hidden) {
					return false;
				} else {
					// Temp set(will be used if only has one showing child)
					this.onlyOneChild = item;
					return true;
				}
			});

			// When there is only one child router, the child router is displayed by default
			if (showingChildren.length === 1) {
				return true;
			}

			// Show parent if there are no child router to display
			if (showingChildren.length === 0) {
				this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
				return true;
			}

			return false;
		},
		resolvePath(routePath) {
			if (isExternal(routePath)) {
				return routePath;
			}

			const participant = this.$store.getters.selectedParticipantStore;
			const basePath = path.resolve(this.basePath, routePath);

			// replace :participant in base path with selected participant
			return basePath.replace(/:participant/g, participant);
		}
	}
};
</script>

<style scopes>
.el-menu-item.is-disabled {
	opacity: 1;
}
</style>
